import "./StartYourProject.module.css";
import Header from "@/reusable_sections/Header";
import StartYourActivation from "./sections/StartYourActivation";
import VisitOurOffice from "./sections/VisitOurOffice";
import FromStoreToDoor from "./sections/FromStoreToDoor";
import GamingSocialFooter from "@/reusable_sections/Footer";
export default function StartYourProjectPage() {
  return <div>
      <Header />
      <StartYourActivation />
      <VisitOurOffice />
      <FromStoreToDoor />
      <GamingSocialFooter />
    </div>;
}